import { useQuery } from '@tanstack/react-query'
import categoriesQueryKeys from 'utils/api/Categories/categoriesQueryKeys'
import { fetchCategoryBreadcrumbs } from 'utils/api/Categories/fetchCategoryBreadcrumbs'

export const useBreadcrumbsCategories = () =>
  useQuery({
    queryKey: categoriesQueryKeys.breadcrumbList(),
    queryFn: fetchCategoryBreadcrumbs,
  })
